// extracted by mini-css-extract-plugin
export var content = "_qu-1";
export var divider = "_qu-0";